import Script from 'next/script';
import { publicEnvConfig } from 'helpers/env';

const AUDIOEYE_SITE_HASH =
	publicEnvConfig.RELEASE_STAGE === 'production' ?
		'66390af289a9e9880d5eb513e2061160'
	:	'5e857069e10507d71fe9c1aaf9d57b7e';
const AUDIOEYE_SCRIPT_URL = `https://wsv3cdn.audioeye-services.com/aem.js?h=${AUDIOEYE_SITE_HASH}`;

// Keep AudioEye's bootstrap intact: the site hash must be set before aem.js loads.
export const rawAudioEyeScript = `!function(){var b=function(){window.__AudioEyeSiteHash = "${AUDIOEYE_SITE_HASH}"; var a=document.createElement("script");a.src="${AUDIOEYE_SCRIPT_URL}";a.type="text/javascript";a.crossOrigin="anonymous";a.setAttribute("async","");document.getElementsByTagName("body")[0].appendChild(a)};"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",b):window.attachEvent&&window.attachEvent("onload",b):b()}();`;

const AudioEyeScript = () => (
	<Script id="audioeye-site-code" strategy="afterInteractive">
		{rawAudioEyeScript}
	</Script>
);

export default AudioEyeScript;
